// extracted by mini-css-extract-plugin
export default {"container":"styles_container__XVqZ5","_1":"styles__1__LYKJz","_2":"styles__2__OkXuQ","switchItem":"styles_switchItem__+phYA"};